import { GridToolbar } from '@mui/x-data-grid';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { BASE_URL } from './BaseUrl';
import InnerHeader from './InnerHeader';
import { StyledDataGrid } from "./StyledDataGrid";
//import FormControlLabel from '@mui/material/FormControlLabel';
import { useDispatch, useSelector } from "react-redux";
import { getRoleData } from "../Store/Role/role-action";
import * as XLSX from "xlsx";
import ExcelJS from 'exceljs';
import { saveAs } from "file-saver";
import Cookies from "js-cookie";

const StudentSearch = () => {
    const [course, setCourse] = useState([])
    const [courseid, setCourseid] = useState('')
    const [batch, setBatch] = useState([])
    const [qualification, setQualification] = useState([])
    const [discipline, setDiscipline] = useState([])
    const [vendordata, setVendorData] = useState([])
    const [totalRecords, setTotalRecords] = useState(0);
    const [totalInterviewed, setTotalInterviewed] = useState(0);
    const [totalPlaced, setTotalPlaced] = useState(0);
    const [paginationModel, setPaginationModel] = useState({
        pageSize: 50,
        page: 0,
    });
    const [errors, setErrors] = useState({
        Course_Id: "",
        Batch_Id: ""
    });
    const [value, setValue] = useState({
        Course_Id: "",
        Batch_Id: "",
        instructor: "",
        description: "",
        feedback: "",
    })
    const getCourseData = () => {

        const data = {
            tablename: "Course_Mst",
            columnname: "Course_Id,Course_Name"
        }

        axios.post(`${BASE_URL}/get_new_data`, data)
            .then((res) => {
                console.log(res.data)
                setCourse(res.data)
            })
            .catch((err) => {
                console.log(err)
            })

    }
    const getBatch = async (id) => {
        setCourseid(id)
        const data = {
            courseid: id
        }
        if (id) {
            axios.post(`${BASE_URL}/getcoursewisebatch`, data)
                .then((res) => {
                    console.log(res.data)
                    setBatch(res.data)
                })
                .catch((err) => {
                    console.log(err)
                })
        } else {
            try {
                const res = await axios.get(`${BASE_URL}/getbatch`, data);

                setBatch(res.data);

            } catch (err) {
                console.error("Error fetching data:", err);
            }
        }
    }
    const getQualification = async () => {
        axios
            .get(`${BASE_URL}/get_qualification`)
            .then((res) => {
                console.log(res.data);
                setQualification(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const getDiscipline = async () => {
        axios
            .get(`${BASE_URL}/get_discipline`)
            .then((res) => {
                console.log(res.data);
                setDiscipline(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };
    useEffect(() => {
        getCourseData()
        getQualification()
        getDiscipline()
    }, [])
    const handleSubmit = (e) => {
        e.preventDefault();

        let hasError = false;
        let newErrors = {
            Course_Id: "",
            Batch_Id: ""
        };

        if (!courseid) {
            newErrors.Course_Id = "Course Id is required";
            hasError = true;
        }

        if (!value.Batch_Id) {
            newErrors.Batch_Id = "Batch Id is required";
            hasError = true;
        }

        setErrors(newErrors);

        if (hasError) return;

        const data = {
            Course_Id: courseid,
            Batch_Id: value.Batch_Id,
            Year: value.years,
            Qualification: value.Qualification,
            Discipline: value.Discipline
        };

        axios.post(`${BASE_URL}/getstudentinterviewreport`, data)
            .then((res) => {
                console.log(res);

                if (!res.data || res.data.length === 0) {
                    alert("No Records Found");
                    setVendorData([]);
                    setTotalRecords(0);
                    setTotalInterviewed(0);
                    setTotalPlaced(0);
                    return;
                }

                 res = res.data.map((row, index) => ({
                    ...row,
                    id: index + 1,   // index starts at 0, so +1 is cleaner
                }));
                setVendorData(res);
                setTotalRecords(res.length);

                const placed = res.filter(item => item.Placement == 'Yes').length;
                const interviewed = res.filter(item => item.cvsent == 'Yes').length;

                console.log(placed,'placed');
                console.log(interviewed,'interviewed');
                setTotalInterviewed(interviewed);
                setTotalPlaced(placed);

                
            })
            .catch((err) => {
                console.log(err);
            });
    };
    const onhandleChange = (e) => {
        setValue((prev) => ({ ...prev, [e.target.name]: e.target.value }))
    }
    const roledata = {
        role: Cookies.get(`role`),
        pageid: 63,
    };

    const dispatch = useDispatch();
    const roleaccess = useSelector((state) => state.roleAssign?.roleAssign[0]?.accessid);

    useEffect(() => {
        dispatch(getRoleData(roledata));
    }, []);
    const columns = [
        { field: 'Student_Name', headerName: 'Student Name', width: 200 },
        { field: 'Final_Result_Percent', headerName: 'Grade', width: 100  },
        { field: 'Batchcode', headerName: 'Batch Code', width: 100 },
        { field: 'ContactNo', headerName: 'Contact No', width: 200 },
        { field: 'Email', headerName: 'Email', width: 200 },
        { field: 'Qualification', headerName: 'Qualification', width: 200 },
        { field: 'Years', headerName: 'Year', width: 200 },
        { field: 'Discipline', headerName: 'Discipline', width: 200 },
        { field: 'Marks', headerName: 'Marks', width: 100,valueGetter: (params) => params.row.Marks },
        { field: 'Design_Exp', headerName: 'Design Exp', width: 100 },
        { field: 'Total_Exp', headerName: 'Total Exp', width: 100 },
        { field: 'cityState', headerName: 'City/State', width: 300 },
        { field: 'Company', headerName: 'Company', width: 300 },
        {
            field: 'ConvocationDate', headerName: 'Convocation Date', width: 300
        },
        {
            field: 'CVDate',
            headerName: 'CV Date',
            width: 200,
            renderCell: (params) => {
                if (!params.value) return "";

                // If already DD-MM-YYYY
                const ddmmyyyyRegex = /^\d{2}-\d{2}-\d{4}$/;
                if (ddmmyyyyRegex.test(params.value)) {
                    return params.value;
                }

                // If yyyymmdd (no dashes)
                if (/^\d{8}$/.test(params.value)) {
                    const year = params.value.substring(0, 4);
                    const month = params.value.substring(4, 6);
                    const day = params.value.substring(6, 8);
                    return `${day}-${month}-${year}`;
                }

                // If yyyy-mm-dd or Date string
                const date = new Date(params.value);
                if (isNaN(date.getTime())) return "";

                return `${String(date.getDate()).padStart(2, "0")}-${String(date.getMonth() + 1).padStart(2, "0")}-${date.getFullYear()}`;
            }
        },

        { field: 'Placement', headerName: 'Placement', width: 200 },
        { field: 'cvsent', headerName: 'CV Sent', width: 200 },
        { field: 'PlacedBy', headerName: 'Placed By', width: 200 },
        { field: 'PLacedRemark', headerName: 'Placed Remark', width: 200 },
        { field: 'BlockPlacement', headerName: 'Block Placement', width: 200 },
        { field: 'Placement_BlockReason', headerName: 'Block Reason', width: 200 },
        { field: 'BlockReason_Remark', headerName: 'Block Remark', width: 200 },
        { field: 'Full_Attendance', headerName: 'Full Attendance', width: 200 }
    ];
    const getRowClassName = (params) => {
        if (params.row.BlockPlacement === 'Yes') {
            return `row-green-${params.id}`;
        } else if (params.row.BlockPlacement === 'No') {
            return `row-red-${params.id}`;
        }
        return '';
    };
    const rowsWithIds = vendordata.map((row) => ({ ...row }));

    const exportToExcel = async () => {
        const data = {
            Course_Id: courseid,
            Batch_Id: value.Batch_Id,
            Year: value.years,
            Qualification: value.Qualification,
            Discipline: value.Discipline
        };

        if (!data.Course_Id || !data.Batch_Id) {
            alert("Please select Course and Batch before exporting.");
            return;
        }

        try {
            const response = await axios.post(`${BASE_URL}/getstudentinterviewreport`, data);
            const result = response.data;

            if (result.length === 0) {
                alert("No data found to export.");
                return;
            }

            const today = new Date().toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
            }).replace(/ /g, '-');

            const totalRecords = result.length;
            const courseName = course.find(c => c.Course_Id === courseid)?.Course_Name || '';
            const batchCode = batch.find(b => b.Batch_Id === value.Batch_Id)?.Batch_code || '';

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Interview Report');

            // Header Rows
            worksheet.addRow(['Suvidya Institute of Technology']);
            worksheet.addRow([`Student search for interview report : ${today}`]);
            worksheet.addRow([]);
            worksheet.addRow([`${courseName} : ${batchCode}`]);
            worksheet.addRow([]);
            worksheet.addRow([`Total Records Found: ${totalRecords}`]);
            worksheet.addRow([]);

            // Column Headers
            worksheet.addRow(columns.map(col => col.headerName));

            // Data Rows with Coloring
            result.forEach(rowData => {
                const dataRow = columns.map((col) => rowData[col.field] ?? "");
                const row = worksheet.addRow(dataRow);

                // Apply color based on BlockPlacement
                if (rowData.BlockPlacement === 'Yes') {
                    row.eachCell((cell) => {
                        cell.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: 'A5D6A7' } // Light Green
                        };
                    });
                } else if (rowData.BlockPlacement === 'No') {
                    row.eachCell((cell) => {
                        cell.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: 'EF9A9A' } // Light Red
                        };
                    });
                }
            });

            // Bold for header rows
            for (let i = 1; i <= 6; i++) {
                const row = worksheet.getRow(i);
                row.font = { bold: true };
            }

            // Bold & background for column headers
            const headerRow = worksheet.getRow(8);
            headerRow.font = { bold: true };
            headerRow.eachCell((cell) => {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'D9E1F2' }
                };
            });

            // Auto Widths
            worksheet.columns.forEach(column => {
                let maxLength = 10;
                column.eachCell({ includeEmpty: true }, cell => {
                    const cellValue = cell.value ? cell.value.toString() : '';
                    maxLength = Math.max(maxLength, cellValue.length);
                });
                column.width = maxLength + 2;
            });

            // Save File
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            saveAs(blob, `Interview_Report_${today}.xlsx`);

        } catch (err) {
            console.error("Export error:", err);
            alert("Failed to export data.");
        }
    };

    return (
        <>
            {/* Add Inline Dynamic Row Coloring Here */}
            <style>
                {rowsWithIds.map((row) => {
                    if (row.BlockPlacement === 'Yes') {
                        return `.MuiDataGrid-row.row-green-${row.Email} { background-color: #a5d6a7 !important; }`;
                    } else if (row.BlockPlacement === 'No') {
                        return `.MuiDataGrid-row.row-red-${row.Email} { background-color: #ef9a9a !important; }`;
                    } else {
                        return '';
                    }
                }).join('\n')}
            </style>
            <div class="container-fluid page-body-wrapper ">
                <InnerHeader />
                <div class="main-panel">
                    <div class="content-wrapper">
                        <div class="row">
                            <div class="col-lg-12 grid-margin stretch-card">
                                <div class="card">
                                    <div class="card-body">
                                        <h4 class="card-title">Student Search For Interview Report</h4>
                                        <hr />
                                        <form class="forms-sample py-3" onSubmit={handleSubmit}>
                                            <div class='row'>

                                                {/* ---- DO NOT TOUCH FORM STRUCTURE ---- */}
                                                <div class="form-group col-lg-4">
                                                    <label for="exampleFormControlSelect1">Course<span className='text-danger'>*</span></label>
                                                    <select class="form-control" id="exampleFormControlSelect1"
                                                        value={courseid} name='coursename' onChange={(e) => getBatch(e.target.value)}>
                                                        <option>Select Course</option>
                                                        {(Array.isArray(course) ? course : []).filter((c) => c && c.IsDelete != 1 && c.isDelete != 1 && c.deleted != 1).map((item) => (
                                                            <option value={item.Course_Id}>{item.Course_Name}</option>
                                                        ))}
                                                    </select>
                                                    {errors.Course_Id && <small className="text-danger">{errors.Course_Id}</small>}
                                                </div>

                                                <div class="form-group col-lg-2">
                                                    <label for="exampleFormControlSelect1">Batch<span className='text-danger'>*</span></label>
                                                    <select class="form-control form-control-lg" id="exampleFormControlSelect1" name='Batch_Id'
                                                        value={value.Batch_Id} onChange={onhandleChange}>
                                                        <option>Select Batch</option>
                                                        {batch.map((item) => (
                                                            <option value={item.Batch_Id}>{item.Batch_code}</option>
                                                        ))}
                                                    </select>
                                                    {errors.Batch_Id && <small className="text-danger">{errors.Batch_Id}</small>}
                                                </div>

                                                <div class="form-group col-lg-2">
                                                    <label for="exampleFormControlSelect1">Year<span className='text-danger'>*</span></label>
                                                    <select class="form-control form-control-lg" id="exampleFormControlSelect1" value={value.years} onChange={onhandleChange} name='years'>
                                                        <option value="">Select Year</option>
                                                        {Array.from({ length: 26 }, (_, i) => 2001 + i).map((year) => (
                                                            <option key={year} value={year}>{year}</option>
                                                        ))}
                                                    </select>
                                                </div>

                                                <div class="form-group col-lg-2">
                                                    <label for="exampleFormControlSelect1">Qualification<span className='text-danger'>*</span></label>
                                                    <select class="form-control form-control-lg" id="exampleFormControlSelect1"
                                                        name='Qualification' value={value.Qualification} onChange={onhandleChange}>
                                                        <option value="">Select Qualification</option>
                                                        {qualification.map((item) => (
                                                            <option key={item.Id} value={item.Id}>{item.Education}</option>
                                                        ))}
                                                    </select>
                                                </div>

                                                <div class="form-group col-lg-2">
                                                    <label for="exampleFormControlSelect1">Discipline<span className='text-danger'>*</span></label>
                                                    <select class="form-control form-control-lg" id="exampleFormControlSelect1"
                                                        name='Discipline' value={value.Discipline} onChange={onhandleChange}>
                                                        <option value="">Select Discipline</option>
                                                        {discipline.map((item) => (
                                                            <option key={item.Id} value={item.Id}>{item.Deciplin}</option>
                                                        ))}
                                                    </select>
                                                </div>

                                            </div>

                                            <button type='submit' class="btn btn-primary mr-2">Go</button>
                                        </form>
                                    </div>
                                </div>
                            </div>

                            {vendordata.length > 0 && (
                                <div class="col-lg-12">
                                    <div class="card">
                                        <div class="card-body">
                                            <div className='d-flex justify-content-between' style={{ borderBottom: "2px solid #dce4ec", width: "100%" }}>
                                                <div>
                                                    <h4 class="card-title">Details </h4>
                                                    <strong>Total Records Found:</strong> {totalRecords} &nbsp;&nbsp;
                                                    <strong>Total Interviewed:</strong> {totalInterviewed} &nbsp;&nbsp;
                                                    <strong>Total Placed:</strong> {totalPlaced}
                                                </div>
                                            </div>

                                            <div style={{ borderLeft: "1px solid #dce4ec", height: "510px", overflow: "hidden" }}>
                                                <StyledDataGrid
                                                    rows={rowsWithIds}
                                                    columns={columns}
                                                    disableColumnSelector
                                                    disableDensitySelector
                                                    rowHeight={35}
                                                    getRowId={(row) => row.id}
                                                    pagination
                                                    paginationModel={paginationModel}
                                                    onPaginationModelChange={setPaginationModel}
                                                    pageSizeOptions={[50]}
                                                    autoHeight={false}
                                                    // 💥 Here you put getRowClassName as a prop
                                                    getRowClassName={(params) => {
                                                        if (params.row.BlockPlacement === 'Yes') {
                                                            return 'row-green';
                                                        } else if (params.row.BlockPlacement === 'No') {
                                                            return 'row-red';
                                                        } else {
                                                            return '';
                                                        }
                                                    }}
                                                    sx={{
                                                        height: 500,
                                                        '& .MuiDataGrid-footerContainer': {
                                                            justifyContent: 'flex-end',
                                                        },
                                                        '& .row-green': {
                                                            backgroundColor: '#a5d6a7 !important',
                                                        },
                                                        '& .row-red': {
                                                            backgroundColor: '#ef9a9a !important',
                                                        },
                                                    }}
                                                    slots={{
                                                        toolbar: GridToolbar
                                                    }}
                                                    slotProps={{
                                                        toolbar: {
                                                            showQuickFilter: true,
                                                        },
                                                    }}
                                                />
                                            </div>

                                            <div>
                                                <button type='button' onClick={exportToExcel} class="btn btn-primary mr-2">Excel</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

}
export default StudentSearch
